/** Part type for UI + DB when Meta cannot hydrate inbound message content (e.g. error 131060). */
export const UNAVAILABLE_INBOUND_PART = 'unavailable-inbound' as const;

export type UnavailableInboundPart = {
  type: typeof UNAVAILABLE_INBOUND_PART;
};

export const UNAVAILABLE_INBOUND_PLACEHOLDER =
  '[Message unavailable - WhatsApp could not deliver the content]';

export function isUnavailableInboundPlaceholderText(text: string | undefined | null): boolean {
  if (!text?.trim()) {
    return false;
  }
  return text.trimStart().startsWith(UNAVAILABLE_INBOUND_PLACEHOLDER);
}
